// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.fi-message-attachments-menu .fi-chat-conversation-edit-message-attachment-menu {
  transition: 0.2s;
  width: 33px;
  height: 33px;
  min-width: 33px;
  margin: 0 0 10px 0;
}
.fi-message-attachments-menu .fi-chat-conversation-edit-message-attachment-menu .mat-icon {
  line-height: 33px;
  width: 33px;
  font-size: 33px;
  overflow: visible;
}
.fi-message-attachments-menu .fi-chat-conversation-edit-message-attachment-menu.rotated {
  transform: rotate(45deg);
}

.editMessageAttachmentMenu .fi-chat-conversation-edit-message-attachment-menu-button .mat-icon {
  font-size: 18px;
  text-align: center;
  line-height: 26px;
  margin-right: 10px;
}`, "",{"version":3,"sources":["webpack://./Source/app/shared/fi-chat/fi-chat-conversation/fi-chat-conversation-edit-message/message-attachments-menu/message-attachments-menu.component.scss"],"names":[],"mappings":"AACI;EACI,gBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,kBAAA;AAAR;AAEQ;EACI,iBAAA;EACA,WAAA;EACA,eAAA;EACA,iBAAA;AAAZ;AAGQ;EACI,wBAAA;AADZ;;AAQQ;EACI,eAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AALZ","sourcesContent":[".fi-message-attachments-menu {\r\n    .fi-chat-conversation-edit-message-attachment-menu {\r\n        transition: 0.2s;\r\n        width: 33px;\r\n        height: 33px;\r\n        min-width: 33px;\r\n        margin: 0 0 10px 0;\r\n\r\n        .mat-icon {\r\n            line-height: 33px;\r\n            width: 33px;\r\n            font-size: 33px;\r\n            overflow: visible;\r\n        }\r\n\r\n        &.rotated {\r\n            transform: rotate(45deg);\r\n        }\r\n    }\r\n}\r\n\r\n.editMessageAttachmentMenu {\r\n    .fi-chat-conversation-edit-message-attachment-menu-button {\r\n        .mat-icon {\r\n            font-size: 18px;\r\n            text-align: center;\r\n            line-height: 26px;\r\n            margin-right: 10px;\r\n        }\r\n    }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
